export const title = 'Your Messages';
